import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static values = {
    url: String,
    orderId: String,
    auto: { type: Boolean, default: false }
  }
  static targets = ['button', 'description', 'loadingIndicator']

  connect() {
    if (this.autoValue) this.translate({ preventDefault: () => {} })
  }

  async translate(event) {
    event.preventDefault()

    if (this.isShowingTranslated()) {
      this.restoreOriginalDescriptions()
      this.updateButtonLabel(false)
      return
    }

    const pageLang = (document.documentElement.lang || 'en').toUpperCase()
    const sourceLang = pageLang === 'EN' ? 'FR' : 'EN'
    const targetLang = pageLang
    const cacheKey = this.translationCacheKey(sourceLang, targetLang)

    const cached = this.getCachedTranslations(cacheKey)
    if (cached) {
      this.updateDescriptions(cached)
      this.updateButtonLabel(true)
      return
    }

    const headers = {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
    const body = JSON.stringify({
      order_id: this.orderIdValue,
      target_lang: targetLang,
      source_lang: sourceLang
    })

    this.setButtonEnabled(false)
    this.showSpinner()
    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        body,
        headers
      })
      const data = await response.json()
      if (response.ok && data.translated) {
        this.setCachedTranslations(cacheKey, data.translated)
        this.updateDescriptions(data.translated)
        this.updateButtonLabel(true)
      }
    } catch (error) {
      console.error('Translate error:', error)
    } finally {
      this.hideSpinner()
      this.setButtonEnabled(true)
    }
  }

  showSpinner() {
    if (this.hasLoadingIndicatorTarget) this.loadingIndicatorTarget.classList.remove('hidden')
  }

  hideSpinner() {
    if (this.hasLoadingIndicatorTarget) this.loadingIndicatorTarget.classList.add('hidden')
  }

  translationCacheKey(sourceLang, targetLang) {
    return `${this.orderIdValue}-${sourceLang}-${targetLang}`
  }

  getCachedTranslations(key) {
    const stored = this.element.dataset.translationCache
    if (!stored) return null
    try {
      const cache = JSON.parse(stored)
      return cache[key] || null
    } catch {
      return null
    }
  }

  setCachedTranslations(key, translated) {
    const stored = this.element.dataset.translationCache
    const cache = stored ? JSON.parse(stored) : {}
    cache[key] = translated
    this.element.dataset.translationCache = JSON.stringify(cache)
  }

  isShowingTranslated() {
    return this.hasButtonTarget && this.buttonTarget.dataset.translated === 'true'
  }

  updateDescriptions(translated) {
    this.descriptionTargets.forEach((el, i) => {
      if (translated[i]) {
        el.dataset.originalText = el.textContent.trim()
        el.textContent = translated[i]
      }
    })
  }

  restoreOriginalDescriptions() {
    this.descriptionTargets.forEach((el) => {
      if (el.dataset.originalText) {
        el.textContent = el.dataset.originalText
        delete el.dataset.originalText
      }
    })
  }

  setButtonEnabled(enabled) {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = !enabled
    }
  }

  updateButtonLabel(translated) {
    if (!this.hasButtonTarget) return
    if (translated) {
      this.buttonTarget.dataset.originalLabel = this.buttonTarget.textContent.trim()
      this.buttonTarget.textContent = this.buttonTarget.dataset.showOriginalLabel || 'Show original'
      this.buttonTarget.dataset.translated = 'true'
    } else {
      this.buttonTarget.textContent = this.buttonTarget.dataset.originalLabel || 'Navigation Language'
      this.buttonTarget.dataset.translated = 'false'
    }
  }
}
